export default "__VITE_ASSET__BX1L7DJb__"